<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    :title="dialogTitle"
    width="520px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="w-full">
      <div class="w-full h-40 px-4 py-4 box-border">
        <div class="w-full h-full py-1 px-3 box-border rounded-small bg-theme-gray flex flex-col">
          <textarea
            class="flex-1 outline-none bg-transparent resize-none theme-text-gray text-medium"
            placeholder="请输入"
            :maxlength="maxSize"
            v-model="content"
          />
          <div class="w-full leading-22 text-right theme-text-gray text-medium">
            {{content.length}}/{{maxSize}}
          </div>
        </div>
      </div>
      <footer class="w-full px-4 py-4 box-border flex justify-end border-t border-solid border-border-gray">
        <el-button size="small" @click="cancelHandle">取 消</el-button>
        <el-button type="primary" size="small" :loading="loading" @click="addHandle">确定发布</el-button>
      </footer>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'
import { addComment } from '@/api/cost-settlement/comment'

export default {
  name: 'CommentDialog',
  mixins: [dialogMixins],
  props: {
    dialogTitle: {
      type: String,
      default: '评论'
    },
    businessId: {
      type: [String, Number],
      default: ''
    },
    businessKey: {
      type: String,
      default: ''
    },
    parentId: {
      type: [String, Number, null],
      default: null
    },
    isRefreshEmit: {
      type: Boolean,
      default: false
    },
    onSuccess: {
      type: [Function, null],
      default: null
    }
  },
  data() {
    return {
      maxSize: 200,
      content: '',
      loading: false
    }
  },
  watch: {
    visibility(bool) {
      if (!bool) {
        this.content = ''
      }
    }
  },
  methods: {
    vaildNullValue() {
      const nils = ['', null, undefined];
      if (nils.includes(this.businessId)) {
        this.$message.warning('无业务对象id');
        return true;
      }
      if (nils.includes(this.businessKey)) {
        this.$message.warning('无业务对象类型');
        return true;
      }
      if (nils.includes(this.content)) {
        this.$message.warning('请填写评论内容');
        return true;
      }
      return false;
    },
    addHandle() {
      const isNull = this.vaildNullValue();
      if (isNull) {
        return;
      }
      const { phone, userId, username } = this.$store.getters.userInfo || {};
      const req = {
        businessId: this.businessId,
        businessKey: this.businessKey,
        content: this.content,
        creatorId: userId,
        creatorName: username,
        creatorPhone: phone,
      };
      if (!['', null, undefined].includes(this.parentId)) {
        req.parentId = this.parentId;
      }
      this.loading = true;
      addComment(req).then((res) => {
        const { code, msg } = res.data || {};
        if (code === 0) {
          this.$message.success('添加评论成功');
          if (typeof this.onSuccess === 'function') {
            this.onSuccess();
          } else {
            this.$emit('success');
          }
          if (this.isRefreshEmit) {
            this.$surveyBus.$emit('refreshByEmit');
          }
          this.cancelHandle();
        } else {
          this.$message.error(msg ?? '添加评论失败');
        }
      }).catch(() => {
        this.$message.error('添加评论失败');
      }).finally(() => {
        this.loading = false;
      })
    },
    cancelHandle() {
      this.visibility = false;
    }
  }
}
</script>